import { Route, Routes } from "react-router-dom";
import AccountLayout from "../layouts/AccountLayout";
import Manage from "../pages/account/Manage";
import Dashboard from "../pages/account/Dashboard";
import Subscription from "../pages/account/Subscription";
import Progress from "../pages/account/Progress";
import AccountShield from "../components/AccountShield";
import AffDashboard from "../pages/affiliate/Dashboard";

export function AccountRoutes() {
  return (
    <Routes>
      <Route element={<AccountLayout />}>
        {[
          { path: "", element: <Dashboard /> },
          { path: "progress", element: <Progress /> },
          { path: "manage", element: <Manage /> },
          { path: "subscription", element: <Subscription /> },
        ].map(({ path, element }) => (
          <Route
            key={path || "index"}
            index={path === ""}
            path={path || undefined}
            element={<AccountShield>{element}</AccountShield>}
          />
        ))}

        <Route
          path="aff-dashboard"
          element={
            <AccountShield allowedRoles={["distributor"]}>
              <AffDashboard />
            </AccountShield>
          }
        />
      </Route>
    </Routes>
  );
}
